export const FALL_BINGO_SEASON = "Fall 2026";
export const BINGO_SIZE = 4;
export const FREE_SPACE = 12;
export const FALL_ACTIVITIES = [
  { icon: "📝", label: "Log Your First Activity", description: "Upload at least one activity to The Joy of Fall platform." },
  { icon: "🤝", label: "Bring a Buddy", description: "Recruit a non-participant friend for one workout and snap a photo." },
  { icon: "🔥", label: "14-Day Streak", description: "Be active 14 days in a row—any distance counts!" },
  { icon: "🍂", label: "Catch a LEAF", description: "Catch a falling leaf during your walk or run." },
  { icon: "🐿️", label: "Wildlife Sighting", description: "Spot real wildlife during your activity—squirrels totally count." },
  { icon: "🎃", label: "Fall Snack", description: "Add some pumpkin, cinnamon or maple syrup to your snack." },
  { icon: "🌅", label: "Sky Session", description: "Start before sunrise or finish after sunset—post the sky pic." },
  { icon: "✌️", label: "Double Activity Day", description: "Log two separate activities in one day—morning + afternoon, etc." },
  { icon: "🏃", label: "Weekend Warrior", description: "Log at least 10 km total over Saturday & Sunday." },
  { icon: "🔢", label: "Palindrome Distance", description: "Complete a symmetrical distance (e.g., 3.43 km or 12.21 km)." },
  { icon: "🍁", label: "Fall Colors", description: "Collect at least 6 leaves of different colors." },
  { icon: "🌧️", label: "Rain Walk/Run", description: "Go out for a walk or run while raining." },
  { icon: "🍁", label: "Free Space", description: "You're awesome. Take this one just for showing up!" },
  { icon: "💛", label: "Carry a Cause", description: "Dedicate one activity to a Canadian charity (tee/tag/share)." },
  { icon: "🔎", label: "I Spy: A-U-T-U-M-N", description: "Find one thing per letter of “AUTUMN” during your workout." },
  { icon: "🗺️", label: "New Route Explorer", description: "Try a street, trail, or park you've never taken before." },
];

export const FALL_ACTIVITY_COUNT = FALL_ACTIVITIES.length - 1;
export const CELEBRATION_VISIT_LIMIT = 5;

export const BINGO_LINES = [
  ...Array.from({ length: BINGO_SIZE }, (_, row) => ({ id: `row-${row}`, cells: Array.from({ length: BINGO_SIZE }, (_, col) => row * BINGO_SIZE + col) })),
  ...Array.from({ length: BINGO_SIZE }, (_, col) => ({ id: `col-${col}`, cells: Array.from({ length: BINGO_SIZE }, (_, row) => row * BINGO_SIZE + col) })),
  { id: "diagonal-down", cells: Array.from({ length: BINGO_SIZE }, (_, index) => index * (BINGO_SIZE + 1)) },
  { id: "diagonal-up", cells: Array.from({ length: BINGO_SIZE }, (_, index) => (index + 1) * (BINGO_SIZE - 1)) },
];

export function getCompletedLines(marked) {
  return BINGO_LINES.filter((line) => line.cells.every((cell) => marked.includes(cell)));
}

export function emptyBingoProgress() {
  return { marked: [FREE_SPACE], celebrated: [], completedAt: null, celebration: null };
}

export function readBingoProgress(storageKey) {
  try {
    return normalizeBingoProgress(JSON.parse(window.localStorage.getItem(storageKey)));
  } catch {
    return emptyBingoProgress();
  }
}

export function normalizeBingoProgress(saved) {
  if (!saved || !Array.isArray(saved.marked)) return emptyBingoProgress();
  const marked = [...new Set([FREE_SPACE, ...saved.marked.filter((cell) => Number.isInteger(cell) && cell >= 0 && cell < FALL_ACTIVITIES.length)])];
  const celebrated = Array.isArray(saved.celebrated)
    ? saved.celebrated.filter((id) => BINGO_LINES.some((line) => line.id === id)) : [];
  const completedAt = typeof saved.completedAt === "string" && Number.isFinite(Date.parse(saved.completedAt))
    ? saved.completedAt : null;
  const banner = saved.celebration;
  const celebration = banner && typeof banner.id === "string"
    && (banner.kind === "line" || banner.kind === "complete")
    && Number.isInteger(banner.visits) && banner.visits >= 1 && banner.visits <= CELEBRATION_VISIT_LIMIT
    && Number.isInteger(banner.lineCount) && banner.lineCount >= 1 && banner.lineCount <= BINGO_LINES.length
    ? { id: banner.id, kind: banner.kind, visits: banner.visits, lineCount: banner.lineCount } : null;
  return { marked, celebrated, completedAt, celebration };
}
